import React from "react";
import { useVenue } from "../api/helpers";

const VenueCoverPhoto = () => {
  const venue = useVenue();
  if (!venue) {
    return null;
  }

  return (
    <>
      <div>
        <img src={venue.coverPhoto} alt="venue header" />
      </div>
      <style jsx>
        {`
          div {
            position: relative;
            background: #f7f8f8;
          }
          img {
            height: auto;
            width: 100%;
            object-fit: cover;
            max-height: 40vh;
          }
        `}
      </style>
    </>
  );
};

export default VenueCoverPhoto;
